import { createLucideIcon } from "lucide-react";

export const ArrowReload = createLucideIcon(
    "ArrowReload",
    [
        [
            "path",
            {
                d: "M18.5 8L20.4548 6.20711C20.8183 5.87377 21 5.70711 21 5.5C21 5.29289 20.8183 5.12623 20.4548 4.79289L18.5 3",
                key: "b669gb",
            },
        ],
        [
            "path",
            {
                d: "M20.5 5.5H9.5C5.78672 5.5 3 8.18503 3 12",
                key: "18w902",
            },
        ],
        [
            "path",
            {
                d: "M3.5 18.5H14.5C18.2133 18.5 21 15.815 21 12",
                key: "tsl0yj",
            },
        ],
        [
            "path",
            {
                d: "M5.5 16L3.54516 17.7929C3.18172 18.1262 3 18.2929 3 18.5C3 18.7071 3.18172 18.8738 3.54516 19.2071L5.5 21",
                key: "896opr",
            },
        ],
    ],
);
